import api from '../services/api';

export default api;
